export const INQUIRY_URL = 'https://portal.hometap.com/inquiry/data/property/';
